module.exports = "/static/assets/5dbf111a76a93a93613ec81c16dfc6d3.svg";